import BaseControlTypeConst from "./BaseControlTypeConst"

export default class LabelTypeConst extends BaseControlTypeConst {

    static FOR = 'for'
    static TEXT = 'text'
}
